import { type FC, useEffect, useState } from "react";
import { type Breadcrumb, useBreadcrumb } from "../../../components/Breadcrumb";
import { Button } from "../../../components/ui/button";
import HrSampleCardComponent from "./component/HrSampleCardComponent";
import MatterSampleCardComponent from "./component/MatterSampleCardComponent";

const BREAD_CRUMBS: Breadcrumb[] = [
  {
    label: "ホーム",
    to: "/",
  },
  {
    label: "メール",
  },
  {
    label: "テンプレートサンプル",
  },
];

export const TemplateSamplePage: FC = () => {
  const { setBreadcrumbItems } = useBreadcrumb();
  const [isMatter, setIsMatter] = useState(true);

  useEffect(() => {
    setBreadcrumbItems(BREAD_CRUMBS);
  }, [setBreadcrumbItems]);

  return (
    <div>
      <div>
        <Button onClick={() => setIsMatter(!isMatter)}>
          {isMatter ? "案件" : "人材"}
        </Button>
      </div>
      {isMatter ? <MatterSampleCardComponent /> : <HrSampleCardComponent />}
    </div>
  );
};
